import { render, staticRenderFns } from "./LKReportsRoadmapBasicStatisticsTable.vue?vue&type=template&id=e2e81a9c&"
import script from "./LKReportsRoadmapBasicStatisticsTable.vue?vue&type=script&lang=js&"
export * from "./LKReportsRoadmapBasicStatisticsTable.vue?vue&type=script&lang=js&"
import style0 from "./LKReportsRoadmapBasicStatisticsTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports